<div class="flex justify-center">
  @if (!resetPasswordSent) {
    <div class="form-container">
      <form [formGroup]="registrationForm">
        <div class="flex">
          <div class="w-full mx-auto">
            <span class="special-font font-bold text-xl">Forgot Password</span>
            <div class="mb-e mt-5 mb-5">
              <label for="email" class="block mt-2 mb-1 text-sm font-medium text-gray-900 ">Email</label>
              <input id="email" type="email"
                     class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                     placeholder="name@company.com" required
                     formControlName="email">
              @if (registrationForm.controls['email'].invalid && (registrationForm.controls['email'].dirty || registrationForm.controls['email'].touched)) {
                <div class="flex gap-2 text-xs pt-2 text-red-500">
                  <custom-icon size="14.4px" iconName="fa-triangle-exclamation"/>
                  @if (registrationForm.controls['email'].errors?.['required']) {
                    <span>Email is required.</span>
                  }
                  @if (registrationForm.controls['email'].errors?.['pattern']) {
                    <span>Email format is invalid.</span>
                  }
                </div>
              }
            </div>
            <button (click)="SendResetPassword()" type="submit" class="submit-button-forms">
              Reset Password
            </button>
          </div>
        </div>
      </form>
    </div>
  }
  @if (resetPasswordSent) {
    <div class="form-container">
      <div class="flex">
        <div class="w-full mx-auto">
          <div class="special-font font-bold text-xl mb-4">Password Reset - Email Sent</div>
          <div class="p-4 bg-white rounded-lg">
            <p class="text-base">We've sent a password reset link to your email.</p>
            <p class="text-base font-semibold text-black mt-4">Didn't Receive the Email?</p>
            <ul class="list-disc pl-5 mt-2 ">
              <li>
                <strong>Check Your Spam Folder</strong><br>Sometimes emails can get mistakenly marked as spam. Please
                check your spam or junk folder to see if our email ended up there.
              </li>
              <li>
                <strong>Correct Email Address</strong><br>Ensure that the email address you entered is the one you
                registered with. If you made a typo or used a different email, you might need to
                <a (click)="tryAgain()" class="text-blue-600 hover:text-blue-800 cursor-pointer">try again</a>.
              </li>
              <li>
                <strong>Wait a Few Minutes</strong><br>Sometimes there can be a delay in email delivery. If you don't
                see our email immediately, it might arrive within a few minutes.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  }
</div>
